<template>
  <div v-if="visitorData" class="code-view bg-theme w-full h-screen px-15">
    <div class="code-tabs" :class="classType">
      <img src="@/assets/visitor/left-active.png" class="left-active" />
      <img src="@/assets/visitor/right-active.png" class="right-active" />
      <div v-if="visitorData.qrcode" class="code-tabs-item text-16" @click="type = 1">
        长期通行码
      </div>
      <div v-if="visitorData.visitor_lists.length" class="code-tabs-item text-16" @click="type = 2">
        临时通行码
      </div>
    </div>
    <div
      class="code-main"
      :style="{
        borderRadius: currentVisitor ? '0 0 20px 20px' : '0 20px 20px 20px'
      }"
    >
      <div class="person-info">
        <div class="person-headimg"><img :src="visitorData.head_pic" /></div>
        <div>
          <div class="person-name">
            <div class="name">{{ visitorData.name }}</div>
            <div v-if="type == 2 && currentVisitor.car_number" class="car">
              {{ currentVisitor.car_number }}
            </div>
          </div>
          <div class="person-com">{{ visitorData.from_name }}</div>
        </div>
      </div>
      <div v-if="type == 1" class="visitor-date">
        <div class="visitor-day">当前时间 {{ currentDay }}</div>
        <div class="visitor-time">{{ currentTime }}</div>
      </div>
      <div v-if="type == 2" class="visitor-date">
        <div class="visitor-day">最近行程</div>
        <div class="visitor-time" @click="handleRecentlyPass">
          {{ currentVisitor.person_time }}
          <van-icon v-if="visitorData.visitor_lists.length > 1" class="ml-4" name="arrow" />
        </div>
      </div>
      <div class="code-line relative">
        <div class="circle bg-theme rounded-full absolute circle-left"></div>
        <div class="circle bg-theme rounded-full absolute circle-right"></div>
        <div class="line"></div>
      </div>
      <div v-if="type == 1">
        <div class="qrcode-img relative"><img :src="visitorData.qrcode" /></div>
        <div class="remote-door text-16" @click="popupRemoteDoor = true">远程开门</div>
      </div>
      <div v-if="type == 2 && currentVisitor">
        <div class="target-visitor">
          <div class="target-name flex justify-between">
            <div class="name">
              {{ currentVisitor.target_name }} |
              {{ currentVisitor.visit_user_name }}
            </div>
          </div>
          <div v-if="currentVisitor.place_names" class="target-location">
            被访对象位置: {{ currentVisitor.place_names }}
          </div>
        </div>
        <div class="open-door" @click="popupOpenDoor = true">查看开门密码</div>
        <div class="qrcode-img relative">
          <div v-if="!isBetween" class="mask absolute w-full h-full bg-white"></div>
          <div v-if="!isBetween" class="text absolute">尚未到达可通行时间</div>
          <img :src="currentVisitor.qrcode" />
        </div>
        <div class="current-time text-14">当前时间：{{ currentDay }} {{ currentTime }}</div>
      </div>

      <div class="visitor-tip text-14">
        已开通刷脸开门服务，<span class="text-theme" @click="toFace">点击这里</span>添加人脸信息
      </div>
    </div>

    <Popup v-model:show="recentlyPupup" title="访客申请" height="70%" :round="true">
      <div class="radio-group-view px-15 py-20">
        <div v-for="(i, x) in visitorData.visitor_lists" :key="x" class="radio-item" @click="radioVisitor = i">
          <div class="icon" :class="radioVisitor.visitor_id == i.visitor_id && 'active'">
            <van-icon name="success" color="#fff" size="16" />
          </div>
          <div class="content">
            <div class="text-default mb-8 text-16">{{ i.person_time }}</div>
            <div class="target text-16">{{ i.visit_stores_name }}</div>
          </div>
        </div>

        <FooterButton :show-cancel="false" ok-text="确认" @submit="submitVisitor" />
      </div>
    </Popup>

    <Popup v-model:show="popupOpenDoor" title="开门密码" height="40%" :round="true">
      <div class="radio-group-view px-15 py-20 h-full overflow-y-scroll box-sizing">
        <div v-for="(i, x) in door_pwd_arr" :key="x" class="open-password-item " @click="i.flag = !i.flag">
          <div class="py-15">
            <div class="flex justify-between text-16">
              <div>{{ i.name }}</div>
              <van-icon v-if="!i.flag" name="arrow" color="#ccc" />
              <van-icon v-else name="arrow-down" color="#ccc" />
            </div>
            <div v-if="i.flag" class="text-16 text-gray mt-6">
              {{ i.door_pwd }}
            </div>
          </div>
        </div>
      </div>
    </Popup>

    <Popup v-model:show="popupRemoteDoor" title="远程开门" height="40%" :round="true">
      <div class="h-full bg-white px-15 overflow-y-scroll">
        <div class="px-15 py-20">
          <div
            v-for="(i, x) in door_arr"
            :key="x"
            class="h-60 flex items-center justify-center "
            @click="handleRemoteDoor(i)"
          >
            <div class="flex justify-between text-16">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script setup>
import dayjs from "dayjs";
import { ref, computed } from "vue";
import to from "await-to-js";
import { visitorService } from "@/service";
import { vLoading } from "@/utils/loading";
import { Dialog, Toast } from "vant";
import Popup from "@/components/PopupPicker/Popup.vue";
import { FooterButton } from "@/components/FormView";
import { useStore } from "@/store";
import { useRouter } from "vue-router";

const router = useRouter();
const store = useStore();
const userInfo = computed(() => store.state.userInfo);

const timer = ref(null);

const currentDay = ref("");
const currentTime = ref("");

const type = ref(1);

const recentlyPupup = ref(false);
const popupOpenDoor = ref(false);
const radioVisitor = ref();
const currentVisitor = ref(null);
const door_pwd_arr = ref([]);
const visitorData = ref(null);
const door_arr = ref([]);
const popupRemoteDoor = ref(false);

const classType = computed(() => {
  if (!visitorData.value) return;
  const bg = visitorData.value.qrcode && visitorData.value.visitor_lists.length ? "code-tabs-bg" : "";
  return visitorData.value.qrcode ? `code-tabs-type${type.value} ${bg}` : `code-tabs-type3 ${bg}`;
});

const isBetween = computed(() => {
  if (currentVisitor.value) {
    const start = currentVisitor.value.person_time_start;
    const end = currentVisitor.value.person_time_end;
    const current = dayjs(`${currentDay.value} ${currentTime.value}`).unix();

    if (current < end && current > start) {
      return true;
    } else {
      false;
    }
  }
  return false;
});

const handleRecentlyPass = () => {
  recentlyPupup.value = true;
  radioVisitor.value = currentVisitor.value;
};

const handleRemoteDoor = item => {
  Dialog.confirm({
    message: `确认打开${item.name}吗？`
  }).then(async () => {
    const [err, data] = await to(visitorService.open_door({ walkable_id: item.id }));
    if (err) {
      Toast.fail("开门失败，请重试");
    } else {
      Toast.success(data.data.message);
    }
  });
};

const getCurrentTime = () => {
  timer.value = setInterval(() => {
    currentDay.value = dayjs().format("YYYY-MM-DD");
    currentTime.value = dayjs().format("HH:mm:ss");
  }, 1000);
};

const getQrcode = async () => {
  if (currentVisitor.value.from == "2") return; // 通过from来区分类型，2是带二维码，而1不带二维码，需要触发接口请求
  const [err, { data }] = await to(
    visitorService.my_visitor_detail({
      visitor_id: currentVisitor.value.visitor_id,
      mobile: visitorData.value.mobile
    })
  );
  if (err) return;

  currentVisitor.value.qrcode = data.data.qrcode;
};

const submitVisitor = () => {
  recentlyPupup.value = false;
  currentVisitor.value = radioVisitor.value;
  getQrcode();
};

const visitorPass = async () => {
  vLoading.start();
  const [err, data] = await to(visitorService.my_pass_new());
  vLoading.stop();

  if (err) return;
  visitorData.value = data.data.data;
  const list = visitorData.value.visitor_lists || [];
  door_arr.value = visitorData.value.door_arr || [];

  if (visitorData.value.qrcode) {
    type.value = 1;
  } else {
    if (list.length) type.value = 2;
  }

  if (list.length) {
    currentVisitor.value = list[0];
    door_pwd_arr.value = list[0].door_pwd_arr.map(i => ({
      ...i,
      flag: false
    }));
    getQrcode();
  }
};

const toFace = () => {
  // userInfo.face_pic区分是否完善
  if (userInfo.value.face_pic) {
    router.push({ name: "faceInfo" });
  } else {
    console.log("111");
    //   wx.navigateTo({ url: "../submitFace/main" });
  }
};

getCurrentTime();
visitorPass();
</script>

<style lang="less" scoped>
.code-view {
  padding-top: 22px;
  padding-bottom: 20px;
  box-sizing: border-box;

  .code-tabs {
    border-radius: 10px 10px 0 0;
    display: flex;
    height: 34px;
    position: relative;
    & > img {
      position: absolute;
      height: 42px;
      width: calc(50% + 15px);
      bottom: 0;
    }
    .code-tabs-item {
      width: 50%;
      text-align: center;
      position: relative;
      line-height: 34px;
      color: #626e81;
    }

    &.code-tabs-bg {
      background-color: #dfecff;
    }

    &.code-tabs-type1 {
      .code-tabs-item:nth-child(3) {
        color: #323c4b;
      }
      .left-active {
        left: 0;
        display: inline-block;
      }
      .right-active {
        display: none;
      }
    }

    &.code-tabs-type2 {
      .code-tabs-item:nth-child(4) {
        color: #323c4b;
      }
      .left-active {
        display: none;
      }
      .right-active {
        right: 0;
        display: inline-block;
      }
    }

    &.code-tabs-type3 {
      .left-active {
        left: 0;
        display: inline-block;
      }
      .right-active {
        display: none;
      }
    }
  }
  .code-main {
    background: #fff;
    border-radius: 0 0 10px 10px;
    padding: 23px 16px 30px;
    .person-info {
      display: flex;
      margin-bottom: 20px;
      .person-headimg {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        margin-left: 4px;
        margin-right: 12px;
        & > img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .person-name {
        margin-bottom: 10px;
        display: flex;
        height: 20px;
        margin-top: 7px;
        align-items: center;
        .name {
          font-size: 16px;
          color: #2d333e;
          margin-right: 10px;
        }
        .car {
          background: #3d6eeb;
          font-size: 14px;
          border-radius: 2px;
          padding: 0 6px;
          color: #fff;
        }
      }
      .person-com {
        font-size: 13px;
        color: #6a717b;
        line-height: 1;
      }
    }

    .visitor-date {
      background: #f6f7fa;
      padding: 10px 0;
      border-radius: 6px;
      text-align: center;
      .visitor-day {
        font-size: 12px;
        color: #959fac;
        line-height: 14px;
        margin-bottom: 6px;
      }
      .visitor-time {
        font-size: 15px;
        height: 24px;
        line-height: 1;
        color: #2c3746;
        display: flex;
        align-items: center;
        justify-content: center;
        & > img {
          width: 8px;
          height: 13px;
          margin-left: 6px;
        }
      }
    }

    .code-line {
      border-bottom: 1px dashed #ccd3df;
      margin-top: 30px;
      .circle {
        width: 16px;
        height: 16px;
        top: -8px;
      }
      .circle-left {
        left: -24px;
      }
      .circle-right {
        right: -24px;
      }
    }

    .qrcode-img {
      width: 240px;
      height: 240px;
      margin: 30px auto 8px;
      & > img {
        width: 100%;
        height: 100%;
      }
      .mask {
        top: 0;
        opacity: 0.95;
      }
      .text {
        top: 0;
        font-size: 16px;
        width: 100%;
        text-align: center;
        color: #fc5820;
        font-weight: 500;
        line-height: 240px;
      }
    }

    .residue-time {
      margin-bottom: 40px;
      text-align: center;
      color: #3d6eeb;
    }
    .current-time {
      text-align: center;
      color: #959fac;
      padding-bottom: 18px;
      border-bottom: 1px dashed #ccd3df;
    }

    .visitor-tip {
      color: #959fac;
      text-align: center;
      padding-top: 16px;
      & > span {
        text-decoration: underline;
      }
    }

    .target-visitor {
      margin-top: 24px;
      .target-name {
        .name {
          color: #2c3746;
          font-size: 14px;
        }
        .target-detail-btn {
          color: #3d6eeb;
          font-size: 12px;
        }
      }
      .target-location {
        font-size: 12px;
        color: #626e81;
        margin-top: 8px;
      }
    }

    .open-door {
      margin-top: 6px;
      color: #3d6eeb;
      font-size: 14px;
    }
  }
}

.remote-door {
  background-color: #3d6eeb;
  color: #fff;
  height: 48px;
  text-align: center;
  line-height: 48px;
  border-radius: 4px;
}

.radio-group-view {
  overflow-y: auto;
  .radio-item {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .icon {
      border: 2px solid #ccd3df;
      margin-right: 16px;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        border: 2px solid #3d6eeb;
        background-color: #3d6eeb;
      }
    }
    .target {
      color: #6a717b;
    }
  }

  .open-password-item {
    & > div {
      border-bottom: 1px solid #ccd3df;
    }
  }
}
</style>
